import React, { useState } from 'react';
import './App.css';
import { api } from '../config/api';
import UserLogin from './UserLogin';
import UserRegister from './UserRegister';
import DescriptionPage from './DescriptionPage';
import AssignSpotsPage from './AssignSpotsPage';

const App = () => {
  // 从 localStorage 中恢复当前页面
  const [currentPage, setCurrentPage] = useState(() => {
    return localStorage.getItem('currentPage') || 'login';
  });

  const [userAuthenticated, setUserAuthenticated] = useState(() => {
    return localStorage.getItem('userAuthenticated') === 'true';
  });

  const [token, setToken] = useState(() => {
    return localStorage.getItem('token') || null;
  });

  // 登录成功处理
  const handleLoginSuccess = (userToken) => {
    setUserAuthenticated(true);
    setToken(userToken);
    localStorage.setItem('userAuthenticated', 'true');
    localStorage.setItem('token', userToken);
    localStorage.setItem('currentPage', 'classes');
    setCurrentPage('classes');
  };

  // 注册成功后跳回登录页面
  const handleRegisterSuccess = () => {
    localStorage.setItem('currentPage', 'login');
    setCurrentPage('login');
  };

  // 登出处理
  const handleLogout = async () => {
    try {
      const response = await fetch(api.logout, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();

      if (response.ok) {
        localStorage.removeItem('userAuthenticated');
        localStorage.removeItem('token');
        localStorage.removeItem('currentPage');
        setUserAuthenticated(false);
        setToken(null);
        setCurrentPage('login');
      } else {
        alert(data.message || 'Logout failed');
      }
    } catch (err) {
      alert('Network error during logout');
    }
  };

  // 渲染当前页面内容
  const renderPage = () => {
    if (!userAuthenticated) {
      return currentPage === 'register' ? (
        <UserRegister onRegisterSuccess={handleRegisterSuccess} />
      ) : (
        <UserLogin
          setToken={setToken}
          onLoginSuccess={handleLoginSuccess}
          onRegisterClick={() => {
            localStorage.setItem('currentPage', 'register');
            setCurrentPage('register');
          }}
        />
      );
    }

    return currentPage === 'descriptions' ? (
      <DescriptionPage />
    ) : (
      <AssignSpotsPage />
    );
  };

  return userAuthenticated ? (
  <div className="app-container">
    <nav className="sidebar">
      <h1>MyBarre to ClassPass</h1>
      <ul>
        <li>
          <button
            className={`nav-button ${currentPage === 'descriptions' ? 'active' : ''}`}
            onClick={() => {
              localStorage.setItem('currentPage', 'descriptions');
              setCurrentPage('descriptions');
            }}
          >
            课程模板
          </button>
        </li>
        <li>
          <button
            className={`nav-button ${currentPage === 'classes' ? 'active' : ''}`}
            onClick={() => {
              localStorage.setItem('currentPage', 'classes');
              setCurrentPage('classes');
            }}
          >
            课节
          </button>
        </li>
        <li>
          <button className="logoutButton" onClick={handleLogout}>
            Logout
          </button>
        </li>
      </ul>
    </nav>
    <main className="main-content">{renderPage()}</main>
  </div>
) : (
  <div className="login-wrapper">{renderPage()}</div>
);
};

export default App;
